import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlLicitacao = '/service/materiais/licitacao/'

class ConsultaLicitacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value) : this.state.adms,
            aguardandoAbertura: filtro.aguardandoAbertura ? filtro.aguardandoAbertura.value : null,
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            situacaoPesquisa: filtro.situacaoPesquisa ? filtro.situacaoPesquisa : null,
            exercicio: filtro.exercicioLicitacao,
            numero: filtro.numeroLicitacao,
            modalidade: filtro.modalidade ? filtro.modalidade.map(e => e.value) : '',
            objeto: filtro.objeto,
            carater: filtro.objetoLicitacao ? filtro.objetoLicitacao.map(e => e.value) : '',
            dataAberturaInicial: filtro.dataAberturaInicial ? moment(filtro.dataAberturaInicial).format('YYYY-MM-DD') : '',
            dataAberturaFinal: filtro.dataAberturaFinal ? moment(filtro.dataAberturaFinal).format('YYYY-MM-DD') : '',
            dataPublicacaoInicial: filtro.dataPublicacaoInicial ? moment(filtro.dataPublicacaoInicial).format('YYYY-MM-DD') : '',
            dataPublicacaoFinal: filtro.dataPublicacaoFinal ? moment(filtro.dataPublicacaoFinal).format('YYYY-MM-DD') : '',
        }
        return this.conex.post(urlLicitacao + 'consultarLicitacao/', JSON.stringify(data))
    }

    consultarLicitacaoMP(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value) : this.state.adms,
            aguardandoAbertura: filtro.aguardandoAbertura ? filtro.aguardandoAbertura.value : null,
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            situacaoPesquisa: filtro.situacaoPesquisa ? filtro.situacaoPesquisa : null,
            exercicio: filtro.exercicioLicitacao,
            numero: filtro.numeroLicitacao,
            modalidade: filtro.modalidade ? filtro.modalidade.map(e => e.value) : '',
            objeto: filtro.objeto,
            carater: filtro.objetoLicitacao ? filtro.objetoLicitacao.map(e => e.value) : '',
            dataAberturaInicial: filtro.dataAberturaInicial ? moment(filtro.dataAberturaInicial).format('YYYY-MM-DD') : '',
            dataAberturaFinal: filtro.dataAberturaFinal ? moment(filtro.dataAberturaFinal).format('YYYY-MM-DD') : '',
            dataPublicacaoInicial: filtro.dataPublicacaoInicial ? moment(filtro.dataPublicacaoInicial).format('YYYY-MM-DD') : '',
            dataPublicacaoFinal: filtro.dataPublicacaoFinal ? moment(filtro.dataPublicacaoFinal).format('YYYY-MM-DD') : '',
            tipoModalidade: ['L', 'O'],
        }
        return this.conex.post(urlLicitacao + 'consultarLicitacaoMP/', JSON.stringify(data))
    }

    respostasImpugnacoesPedidosMP(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value) : this.state.adms,
            aguardandoAbertura: filtro.aguardandoAbertura ? filtro.aguardandoAbertura.value : null,
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            situacaoPesquisa: filtro.situacaoPesquisa ? filtro.situacaoPesquisa : null,
            exercicio: filtro.exercicioLicitacao,
            numero: filtro.numeroLicitacao,
            modalidade: filtro.modalidade ? filtro.modalidade.map(e => e.value) : '',
            objeto: filtro.objeto,
            carater: filtro.objetoLicitacao ? filtro.objetoLicitacao.map(e => e.value) : '',
            dataAberturaInicial: filtro.dataAberturaInicial ? moment(filtro.dataAberturaInicial).format('YYYY-MM-DD') : '',
            dataAberturaFinal: filtro.dataAberturaFinal ? moment(filtro.dataAberturaFinal).format('YYYY-MM-DD') : '',
            dataPublicacaoInicial: filtro.dataPublicacaoInicial ? moment(filtro.dataPublicacaoInicial).format('YYYY-MM-DD') : '',
            dataPublicacaoFinal: filtro.dataPublicacaoFinal ? moment(filtro.dataPublicacaoFinal).format('YYYY-MM-DD') : '',
            possuiQuestionamento: 1,
        }
        return this.conex.post(urlLicitacao + 'consultarLicitacaoMP/', JSON.stringify(data))
    }

    dispensasInexigibilidadesMP(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value) : this.state.adms,
            aguardandoAbertura: filtro.aguardandoAbertura ? filtro.aguardandoAbertura.value : null,
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            situacaoPesquisa: filtro.situacaoPesquisa ? filtro.situacaoPesquisa : null,
            exercicio: filtro.exercicioLicitacao,
            numero: filtro.numeroLicitacao,
            modalidade: filtro.modalidade ? filtro.modalidade.map(e => e.value) : '',
            objeto: filtro.objeto,
            carater: filtro.objetoLicitacao ? filtro.objetoLicitacao.map(e => e.value) : '',
            dataAberturaInicial: filtro.dataAberturaInicial ? moment(filtro.dataAberturaInicial).format('YYYY-MM-DD') : '',
            dataAberturaFinal: filtro.dataAberturaFinal ? moment(filtro.dataAberturaFinal).format('YYYY-MM-DD') : '',
            dataPublicacaoInicial: filtro.dataPublicacaoInicial ? moment(filtro.dataPublicacaoInicial).format('YYYY-MM-DD') : '',
            dataPublicacaoFinal: filtro.dataPublicacaoFinal ? moment(filtro.dataPublicacaoFinal).format('YYYY-MM-DD') : '',
            tipoModalidade: ['D', 'I'],
            situacao: ['D'],
        }
        return this.conex.post(urlLicitacao + 'consultarLicitacaoMP/', JSON.stringify(data))
    }

    interesseContratacaoDispensaMP(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value) : this.state.adms,
            aguardandoAbertura: filtro.aguardandoAbertura ? filtro.aguardandoAbertura.value : null,
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            situacaoPesquisa: filtro.situacaoPesquisa ? filtro.situacaoPesquisa : null,
            exercicio: filtro.exercicioLicitacao,
            numero: filtro.numeroLicitacao,
            modalidade: filtro.modalidade ? filtro.modalidade.map(e => e.value) : '',
            objeto: filtro.objeto,
            carater: filtro.objetoLicitacao ? filtro.objetoLicitacao.map(e => e.value) : '',
            dataAberturaInicial: filtro.dataAberturaInicial ? moment(filtro.dataAberturaInicial).format('YYYY-MM-DD') : '',
            dataAberturaFinal: filtro.dataAberturaFinal ? moment(filtro.dataAberturaFinal).format('YYYY-MM-DD') : '',
            dataPublicacaoInicial: filtro.dataPublicacaoInicial ? moment(filtro.dataPublicacaoInicial).format('YYYY-MM-DD') : '',
            dataPublicacaoFinal: filtro.dataPublicacaoFinal ? moment(filtro.dataPublicacaoFinal).format('YYYY-MM-DD') : '',
            tipoModalidade: ['D'],
            situacao: ['V', 'H', 'R', 'A', 'C', 'N', 'F', 'E'],
        }
        return this.conex.post(urlLicitacao + 'consultarLicitacaoMP/', JSON.stringify(data))
    }

    editalChamamentoInteressadosMP(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value) : this.state.adms,
            aguardandoAbertura: filtro.aguardandoAbertura ? filtro.aguardandoAbertura.value : null,
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            situacaoPesquisa: filtro.situacaoPesquisa ? filtro.situacaoPesquisa : null,
            exercicio: filtro.exercicioLicitacao,
            numero: filtro.numeroLicitacao,
            modalidade: filtro.modalidade ? filtro.modalidade.map(e => e.value) : '',
            objeto: filtro.objeto,
            carater: filtro.objetoLicitacao ? filtro.objetoLicitacao.map(e => e.value) : '',
            dataAberturaInicial: filtro.dataAberturaInicial ? moment(filtro.dataAberturaInicial).format('YYYY-MM-DD') : '',
            dataAberturaFinal: filtro.dataAberturaFinal ? moment(filtro.dataAberturaFinal).format('YYYY-MM-DD') : '',
            dataPublicacaoInicial: filtro.dataPublicacaoInicial ? moment(filtro.dataPublicacaoInicial).format('YYYY-MM-DD') : '',
            dataPublicacaoFinal: filtro.dataPublicacaoFinal ? moment(filtro.dataPublicacaoFinal).format('YYYY-MM-DD') : '',
            tipoModalidade: ['C'],
        }
        return this.conex.post(urlLicitacao + 'consultarLicitacaoMP/', JSON.stringify(data))
    }

    rolLicitantesMP(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value) : this.state.adms,
            aguardandoAbertura: filtro.aguardandoAbertura ? filtro.aguardandoAbertura.value : null,
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            situacaoPesquisa: filtro.situacaoPesquisa ? filtro.situacaoPesquisa : null,
            exercicio: filtro.exercicioLicitacao,
            numero: filtro.numeroLicitacao,
            modalidade: filtro.modalidade ? filtro.modalidade.map(e => e.value) : '',
            objeto: filtro.objeto,
            carater: filtro.objetoLicitacao ? filtro.objetoLicitacao.map(e => e.value) : '',
            dataAberturaInicial: filtro.dataAberturaInicial ? moment(filtro.dataAberturaInicial).format('YYYY-MM-DD') : '',
            dataAberturaFinal: filtro.dataAberturaFinal ? moment(filtro.dataAberturaFinal).format('YYYY-MM-DD') : '',
            dataPublicacaoInicial: filtro.dataPublicacaoInicial ? moment(filtro.dataPublicacaoInicial).format('YYYY-MM-DD') : '',
            dataPublicacaoFinal: filtro.dataPublicacaoFinal ? moment(filtro.dataPublicacaoFinal).format('YYYY-MM-DD') : '',
            tipoModalidade: ['Q'],
        }
        return this.conex.post(urlLicitacao + 'consultarLicitacaoMP/', JSON.stringify(data))
    }
}

export default ConsultaLicitacaoService
